import { makeAutoObservable } from 'mobx'
import { DELETED_CONTACT_AVATAR_INFO, type IAvatarInfo } from 'shared/ui'
import { type IResponseClickToTextStatisticLeadsItem } from 'entities/ClickToText/api/type'
import { Contact } from 'entities/Contacts/model/Contact'

export type IClickToTextStatisticsLeads = ClickToTextStatisticsLeads

export class ClickToTextStatisticsLeads {
  private readonly _id: number
  private readonly _contact: Contact
  private readonly _sendTime: string

  constructor(item: IResponseClickToTextStatisticLeadsItem) {
    this._id = item.id
    this._contact = new Contact(item.contact)
    this._sendTime = item.send_time

    makeAutoObservable(this)
  }

  get id() {
    return this._id
  }
  get contact() {
    return this._contact
  }
  get sendTime() {
    return this._sendTime
  }
  get isDeleted() {
    return !!this.contact.archived_at
  }
  get isCheckboxDisabled() {
    return this.isDeleted
  }
  get avatarInfo() {
    const isPhoneAbbr = !this.contact.first_name && !this.contact.last_name
    const info: IAvatarInfo = this.isDeleted
      ? DELETED_CONTACT_AVATAR_INFO
      : {
          isPhoneAbbr,
          color: this.contact.color || '',
          firstName: this.contact.first_name || '',
          lastName: this.contact.last_name || '',
          number: this.contact.formatted_number || '',
          image: this.contact.photo_url || '',
          icon: this.contact.icon,
        }

    return info
  }
}
